import axios from 'axios';

// Configureer axios basis URL
axios.defaults.baseURL = process.env.REACT_APP_API_URL;

// Voeg een request interceptor toe voor de token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios; 